define([
   	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		// String: View Id from view XML
		id: null,

		// String: URL of the root node of this view
		rootNodeURL: null,

		// String: the type where this view is defined
		originalType: null,

		// csi.comm.Request[]: requests of this view
		requests: null,

		// csi.prefs.PreferenceView: the custom view
		pref: null,

		// Spec: the specification for the column filtering
		specMap: null,

		// ColumnFilterValue[]: an array of column filter values
		columnFilterValues: null,

		constructor: function(viewId,originalType,rootNodeURL) {
			this.id = viewId;
			this.originalType = originalType;
			this.rootNodeURL = rootNodeURL;
		}
	});
});